import "../Login/Login.scss";

import React, { useEffect, useState } from "react";
import TextInputField from "../../Components/TextInput/TextInputField";
import { Divider, InputAdornment, SvgIcon, CircularProgress, Box } from "@mui/material";
import { Mail } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ButtonField from "../../Components/Button/ButtonField";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as Arrow } from "../../Assets/Images/Arrow.svg";

import { useFormik } from "formik";
import * as Yup from "yup";
import { IForgetPasswordMail } from "./IForgetPassword";
import {
  clearforgotPassData,
  forgotPassStart,
} from "../../Redux/Slicers/LoginSlicer/LoginSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import FailureResponseDialog from "../../Components/FailureResponseDialog/FailureResponseDialog";
import Logo from '../../Assets/Images/navami_logo.webp';
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";

interface ForgotProps {
  email: string;
}
const ForgotPasswordMail = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const loginResponse = useAppSelector((state) => state.LoginSlicer);
  const nav = useNavigate();
  const forgotInitialValues: ForgotProps = {
    email: '',
  } as IForgetPasswordMail;

  const forgotSchema = Yup.object({
    email: Yup.string().email('Invalid email').required('Email is required'),
  });

  const forgotForm = useFormik({
    initialValues: forgotInitialValues,
    validationSchema: forgotSchema,
    onSubmit: (value) => {
      dispatch(forgotPassStart(value));
    },
  });
  

  useEffect(() => {
    return () => {
      dispatch(clearforgotPassData());
    };
  }, [dispatch]);
  return (
    <div className="backGround">
      <form
        onSubmit={forgotForm.handleSubmit}
        className="main">
        <>
          <div className="header">
            {/* <SvgIcon component={Logo} inheritViewBox /> */}
            <img
              src={Logo}
              alt="Navami Logo"
            />

            <div
              className="heading"
              style={{
                textAlign: 'center',
                color: '#a8cc3d',
                marginTop: '10px',
              }}>
              FORGOT PASSWORD
            </div>
            <div className="subHeading"></div>
          </div>

          <div className="textFields">
            <TextInputField
              className="textField"
              type="text"
              name="email"
              label="Email"
              value={forgotForm.values.email}
              onChange={forgotForm.handleChange}
              onBlur={forgotForm.handleBlur}
              helperText={forgotForm.touched.email && forgotForm.errors.email}
              error={
                forgotForm.touched.email && Boolean(forgotForm.errors.email)
              }
              disabled={loginResponse.isLoading}
            />
          </div>
          <div className="textFields">
            <ButtonField
              className="buttonfield"
              size="large"
              type="submit"
              disabled={loginResponse.isLoading}>
              {loginResponse.isLoading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={20} sx={{ color: 'white' }} />
                  <span>SUBMITTING...</span>
                </Box>
              ) : (
                'SUBMIT'
              )}
            </ButtonField>
            <NavLink
              className="login_page"
              to={'/login'}
              style={{ pointerEvents: loginResponse.isLoading ? 'none' : 'auto' }}>
              <ButtonField
                className="back_button"
                size="large"
                disabled={loginResponse.isLoading}>
                <SvgIcon
                  component={Arrow}
                  inheritViewBox
                />{' '}
                Back
              </ButtonField>
              {/* <ButtonField className="buttonfield">Login</ButtonField> */}
            </NavLink>
          </div>
        </>
      </form>
      {(() => {
        const isSuccess = loginResponse.data?.responseMessage === 'success' || 
                          loginResponse.data?.responseCode === 200 || 
                          (loginResponse.data?.response?.status === true && loginResponse.data?.responseCode !== undefined && loginResponse.data?.responseCode >= 200 && loginResponse.data?.responseCode < 300);
        
        return isSuccess ? (
          <ResponseDialog 
            response={loginResponse.data}
            onClose={() => {
              // Navigate to login when OK is clicked
              nav('/login');
            }}
          />
        ) : (
          <FailureResponseDialog response={loginResponse.data} />
        );
      })()}
    </div>
  );
};

export default ForgotPasswordMail;
